export default __webpack_public_path__ + "static/ui-instructions@2x-efe55e3528aadb3d4ddb53740eb950a0.png";